// src/store/index.js
import { createStore } from 'vuex'
import auth from './modules/auth'
import leads from './modules/leads'
import dialer from './modules/dialer'
import calls from './modules/calls'
import invoices from './modules/invoices'
import inventory from './modules/inventory'
const store = createStore({
  modules: { auth, leads,dialer,calls,invoices,inventory },
})

export default store
